/** Before using this, check whether there's 'REACT_APP_ENV' on Bitbucket => Repository Settings => Deployments Variables */
const isNotProduction = () => {
  return process.env.REACT_APP_ENV !== 'production';
};

export { isNotProduction };
